<div class="px-2.5 py-0.5 rounded-full w-fit font-title font-medium text-theme-xs"
  [class.bg-warning-50]="sector().state === SectorState.INCIDENCE"
  [class.text-warning-600]="sector().state === SectorState.INCIDENCE"
  [class.bg-error-50]="sector().state === SectorState.MALFUNCTION"
  [class.text-error-600]="sector().state === SectorState.MALFUNCTION">
  {{sectorStateReasonText()}}
</div>